import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import { Link } from 'react-router-dom';

import styles from './styles.module.scss';

interface ErrorPageProps {
  title: string,
  logo: React.ReactNode,
  linkHref: string,
  linkText: string,
}

const ErrorPage: FC<PropsWithChildren<ErrorPageProps>> = ({
  children,
  title,
  logo,
  linkHref,
  linkText,
}) => (
  <div className={styles.errorPage}>
    <div className={styles.errorContainer}>
      {logo}
      <h1>{title}</h1>
      <div>
        {children}
      </div>
      <Link to={linkHref} className={styles.link}>
        {linkText}
      </Link>
    </div>
  </div>
);

export default ErrorPage;
